import { useState, useEffect } from 'react';

interface CardDimensions {
  width: string;
  height: string;
  fontSize: string;
  iconSize: string;
  qrSize: number;
  avatarSize: string;
}

export const useResponsiveCard = (): CardDimensions => {
  const [dimensions, setDimensions] = useState<CardDimensions>({
    width: '336px',
    height: '760px',
    fontSize: '1rem',
    iconSize: '40px',
    qrSize: 150,
    avatarSize: '70px'
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      
      if (width < 360) {
        // Extra small phones
        setDimensions({
          width: '280px',
          height: '500px',
          fontSize: '0.85rem',
          iconSize: '32px',
          qrSize: 130,
          avatarSize: '50px'
        });
      } else if (width < 576) {
        // Small phones
        setDimensions({
          width: '320px',
          height: '550px',
          fontSize: '0.9rem',
          iconSize: '36px',
          qrSize: 140,
          avatarSize: '60px'
        });
      } else if (width < 768) {
        // Medium phones and small tablets
        setDimensions({
          width: '340px',
          height: '600px',
          fontSize: '1rem',
          iconSize: '40px',
          qrSize: 160,
          avatarSize: '70px'
        });
      } else {
        // Larger screens
        setDimensions({
          width: '360px',
          height: '640px',
          fontSize: '1.1rem',
          iconSize: '50px',
          qrSize: 180,
          avatarSize: '80px'
        });
      }
    };

    // Initial call
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Clean up
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return dimensions;
}; 